module.exports = __webpack_public_path__ + "img/office-2010-taida.a77efe19.jpg";